<template>
  <div>
    <van-cell class="ry-form__yes-no" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead">
          {{currentText}}
        </div>
        <template v-if="!isRead">
          <div
            v-if="!current.showAsCheckbox"
            class="ry-form__yes-no-body">
            <span v-if="current.closeText">{{current.closeText}}</span>
            <span>
            <van-switch
              size="20"
              v-model="checked"
              :disabled="isReadOnly"
              @change="controlChange"
              :active-color="current.openColor"
              :inactive-color="current.closeColor">
            </van-switch>
           </span>
            <span v-if="current.openText">{{current.openText}}</span>
          </div>
          <div v-else>
            <van-checkbox
              v-model="checked"
              shape="square"
              :disabled="isReadOnly"
              @change="controlChange"
              icon-size="16">
              {{current.checkboxShowText}}
            </van-checkbox>
          </div>
        </template>
      </template>
    </van-cell>


    <div v-else class="ry-form-item-compact ry-form__yes-no-compact">

      <van-field
        :label="current.title"
        :label-class="{'readonly-field-label': !isRead && isReadOnly}"
        :required="Boolean(!isRead && current.required)">
        <template #input>

          <div v-if="isRead">
            {{currentText}}
          </div>

          <template v-else>
            <div v-if="!current.showAsCheckbox" class="ry-form__yes-no-body">
              <span v-if="current.closeText">{{current.closeText}}</span>
              <span>
            <van-switch
              size="20"
              v-model="checked"
              :disabled="isReadOnly"
              @change="controlChange"
              :active-color="current.openColor"
              :inactive-color="current.closeColor">
            </van-switch>
           </span>
              <span v-if="current.openText">{{current.openText}}</span>
            </div>
            <van-checkbox
              v-else
              v-model="checked"
              shape="square"
              :disabled="isReadOnly"
              @change="controlChange"
              icon-size="16">
              {{current.checkboxShowText}}
            </van-checkbox>
          </template>

        </template>
      </van-field>
    </div>

  </div>

</template>

<script>
  import {current} from './mixin'

  export default {
    mixins: [current],
    computed: {
      checked: {
        get() {
          return !!this.current.value
        },
        set(bol) {
          this.current.value = Number(bol)
        }
      },
      currentText() {
        if (this.current.value) {
          return this.current.openText || '是'
        } else {
          return this.current.closeText || '否'
        }
      }
    }
  }
</script>
